import React, { useCallback } from "react";
import "./styles.css";
import "./StreamDetails/styles.css";
import StreamLine from "./StreamLine";
import Slider from "./Slider";
import Stream from "./Stream";
import { useDispatch, useSelector } from "react-redux";
import { setSimulationSpeedAction } from "../../entities";
import {
  selectorGetActiveStream,
  selectorGetTickDuration
} from "../../entities/selectors";
import EmptyStream from "./Stream/EmptyStream";
import { StreamDetails } from "./StreamDetails";
import { bgColors } from "../consts";
import SipLine from "../SipLine";
import { config } from "../../config";

const Streams = ({
  nbbo,
  start,
  steps,
  currentTick,
  stream_executions,
  simulation,
  chartArray,
  orders
}) => {
  const strms = React.useRef([]);

  const stepStreams = steps?.[currentTick]?.streams;
  const streams = Object.keys(stream_executions).map(el => ({
    [el]: Object.values(stream_executions[el])
  }));
  const renderStreams = streams
    .map(stream =>
      Object.keys(stream).map(el => {
        const tmp = Object.values(stream[el]).map(e => ({
          sid: el,
          exec_price: e.exec_price,
          exec_qty: e.exec_qty,
          exec_rate: e.exec_rate,
          tp: Number(e.tp_id.replace("TP", "")),
          bid: e.tp_qty,
          offer: e.tp_price,
          is_done: false
        }));
        return tmp;
      })
    )
    .flat();
  strms.current = [];
  stepStreams?.forEach(s => {
    strms.current.push(
      renderStreams?.find(rs => rs?.[0]?.sid === s?.stream_id)
    );
  });

  const dispatch = useDispatch();
  const setSimulationSpeed = useCallback(
    payload => dispatch(setSimulationSpeedAction(payload)),
    [dispatch]
  );
  const tickDuration = useSelector(selectorGetTickDuration);
  const activeStream = useSelector(selectorGetActiveStream);

  const currentStreamInfo = stream_executions[activeStream];

  const filteredData = chartArray?.map(item => {
    return {
      quantity: item.quantity,
      price: item.price,
      isDynamic: item.is_dynamic,
      isReference: item.is_reference
    };
  });  

  return (
    <div className="streams-wrapper">
      <div className="streams-header">
        <div className="streams-header-title">{config.streams.title}</div>
        <div
          className={`streams-header-info ${
            simulation ? "streams-header-info-end" : ""
          }`}
        >
          {!simulation && (
            <div className="streams-header-speed">
              <div className="slider-learn">{config.streams.learn}</div>
              <Slider onChange={setSimulationSpeed} />
              <div className="slider-blur">{config.streams.blur}</div>
            </div>
          )}
          <div className="streams-header-nbbo">
            <div className="streams-header-nbbo-value">
              {
                <>
                  <span>{typeof nbbo[0] === "number" ? nbbo[0].toFixed(2) : nbbo[0]}</span>
                  <span>|</span>
                  <span>{typeof nbbo[1] === "number" ? nbbo[1].toFixed(2) : nbbo[1]}</span>
                </>
              }
            </div>
            <div className="streams-header-nbbo-label">
              {config.streams.nbbo}
            </div>
          </div>
        </div>
      </div>
      <div className="streams-title-sip">
        <div className="streams-title-sip-first">
          <span className="streams-title-sip-first-match">
            {config.streams.match}
          </span>
          <span className="header-rate">{config.streams.rate}</span>
          <span className="header-avg">{config.streams.average}</span>
          <span className="header-qty">{config.streams.executedQty}</span>
        </div>
        <div className="streams-title-sip-second">
          {simulation ? (
            <StreamLine
              start={start}
              active={true}
              startStep={0}
              data={filteredData}
              currentTick={currentTick}
              tickDuration={tickDuration}
              simulation={simulation}
              isSip={true}
              className="sip-wrapper"
            />
          ) : (
            <SipLine tickDuration={tickDuration} />
          )}
          <div className="streams-title-sip-label">{config.streams.sip}</div>
        </div>
      </div>
      <div className="streams-table">
        {strms?.current.length < 4
          ? strms?.current
              .concat(Array(4 - strms.current.length).fill(null))
              .map((stream, i) => {
                if (stream && stream[i]?.sid) {
                  return (
                    <div key={`${stream[i]?.sid} ${i}`}>
                      <Stream
                        key={stream[0]?.sid}
                        start={start}
                        streamData={stream}
                        stepStreams={stepStreams}
                        currentTick={currentTick}
                        tickDuration={tickDuration}
                        simulation={simulation}
                        bgcolor={bgColors[stream?.[0]?.sid]}
                        actualOrders={orders}
                      />
                    </div>
                  );
                } else {
                  return (
                    <div key={i}>
                      <EmptyStream index={i} />
                    </div>
                  );
                }
              })
          : strms.current.map(stream => (
              <div key={stream[0]?.sid}>
                <Stream
                  key={stream[0]?.sid}
                  start={start}
                  streamData={stream}
                  stepStreams={stepStreams}
                  currentTick={currentTick}
                  tickDuration={tickDuration}
                  simulation={simulation}
                  bgcolor={bgColors[stream?.[0]?.sid]}
                  actualOrders={orders}
                />
              </div>
            ))}
      </div>
      {activeStream && (
        <StreamDetails
          details={currentStreamInfo}
          id={activeStream}
          currentTick={currentTick}
        />
      )}
    </div>
  );
};

export default React.memo(Streams);
